/**
 * What a Mantine NumberInput with fixed decimals reports, as a number or "" for an empty field.
 *
 * With `fixedDecimalScale` the input shows "12.00", and Mantine hands the change handler the text "12.00" rather than
 * the number 12 (a trailing zero keeps it a string so the caret does not jump). Treating anything but a number as
 * empty lost every typed amount; the store walk on staging found it on 2026-09-26.
 */
export function moneyValue(value: number | string): number | "" {
  if (typeof value === "number") return Number.isFinite(value) ? value : "";
  const text = value.trim();
  if (text === "") return "";
  const parsed = Number(text);
  return Number.isFinite(parsed) ? parsed : "";
}
